import { Component } from '@angular/core';

@Component({
  selector: 'app-deficiency-reports',
  templateUrl: './deficiency-reports.component.html',
  styleUrls: ['./deficiency-reports.component.scss']
})
export class DeficiencyReportsComponent {

}
